import { mapGetters, mapActions } from 'vuex'
import Configuration from '@/agilis/util/Configuration'
import PriceItemDataTable from './datatable/PriceItemDataTable.vue'

let lastListPriceSelected = null

export default {
  name: 'PriceItemTable',

  props: {
    propTitle: String
  },

  components: {
    PriceItemDataTable
  },

  created () {
    if (!this.currentPriceList) {
      // Check for priceListId defined in context (url query params set by the router)
      this.setCurrentListPrice(this.priceListFromContext)
    }

    if (this.mode === 'view' || this.mode === 'edit') {
      this.preloadItem()
    } else if (this.mode !== 'insert' && lastListPriceSelected) {
      this.setCurrentListPrice(lastListPriceSelected)
    }
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId',
      selectedContext: 'contextStore/selectedContext',
      trackerTypeId: 'contextStore/trackerTypeId',
      trackerId: 'contextStore/trackerId',
      priceListFromContext: 'contextStore/parentTrackerId', // TODO: make it generic: handle any query params
      mode: 'contextStore/contextMode'
    }),

    api () {
      return `/api/${this.applicationId}/priceitem`
    },

    priceListOptions () {
      const trackerType = Configuration.getTrackerType(this.applicationId, this.trackerTypeId)
      return Object.values(trackerType.priceList || {}).map((priceList) => {
        if (Configuration.auth.userCanAccessFeatureInclude(this.selectedContext, priceList.id)) {
          return {
            value: priceList.id,
            text: this.$t(priceList.name),
            description: this.$t(priceList.description),
            group: priceList.group
          }
        }
      }).filter(Boolean)
    },

    groups () {
      return this.priceListOptions.reduce(function (groups, item) {
        const g = item.group
        groups[g] = groups[g] || []
        groups[g].push(item)
        return groups
      }, {})
    },

    dataTableConfiguration () {
      const trackerType = Configuration.getTrackerType(this.applicationId, this.trackerTypeId)
      if (this.currentPriceList && trackerType?.priceList[this.currentPriceList]) {
        let dataTable = trackerType.priceList[this.currentPriceList].dataTable

        return Configuration.datatable.getDatatableOverride(dataTable, this.applicationId, this.workspaceId, this.currentPriceList)
      }
      return null
    },

    currentPriceListDescription () {
      const trackerType = Configuration.getTrackerType(this.applicationId, this.trackerTypeId)
      if (this.currentPriceList && trackerType?.priceList[this.currentPriceList]) {
        const description = trackerType.priceList[this.currentPriceList].description
        return description && this.$t(description)
      }
      return null
    },

    currentPriceListTitle () {
      const priceList = this.priceListOptions.find(priceList => priceList.value === this.currentPriceList)
      if (priceList) return priceList.text
    }
  },

  data () {
    return {
      currentPriceList: null,
      currentPriceListMenu: false
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError',
      'startLoader': 'loaderStore/startLoader',
      'stopLoader': 'loaderStore/stopLoader'
    }),

    async preloadItem () {
      this.startLoader({ id: 'edit-tracker' })
      const url = this.$axios.agilisUrlDataTableEdit(this.api, this.trackerId)
      this.$axios
        .get(
          url,
          this.$axios.agilisRequestConfig(url))
        .then((response) => {
          const item = response.data
          this.setCurrentListPrice(item.priceListId)
        })
        .catch((error) => {
          this.notifyError(error)
        })
        .finally(() => {
          this.stopLoader({ id: 'edit-tracker' })
        })
    },

    setCurrentListPrice (nextListPrice) {
      this.currentPriceList = nextListPrice
    },

    changePriceList (item) {
      this.currentPriceList = item.value
    },

    trigMenu () {
      if (!this.currentPriceListMenu) this.currentPriceListMenu = true
    }
  },

  watch: {
    currentPriceList (nextListPrice) {
      lastListPriceSelected = nextListPrice // use a singleton variable to persist the last selected value in session
    }
  }
}
